module.exports = __webpack_public_path__ + "images/emoji/anguished.c533fbff99e3d8d0e825.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/anguished.png
// module id = JkP8
// module chunks = 2